import {CREATE_REPEATING_INVOICE, GET_REPEATING_INVOICE, UPDATE_REPEATING_INVOICE} from 'admin/gql/RepeatingInvoice.gql'
import clearCache from 'admin/hooks/clearCache'
import useDestroyable from 'admin/hooks/useDestroyable'
import {useMutation, useQuery} from 'admin/lib/apollo'
import {calculateLineItems} from '../lib/tax'

export default (organisationId, repeatingInvoiceId) => {
  const {data: {repeatingInvoice = {}} = {}} = useQuery(GET_REPEATING_INVOICE, {
    variables: {organisationId, repeatingInvoiceId},
    skip: !repeatingInvoiceId
  })

  const [create, {error: createError}] = useMutation(CREATE_REPEATING_INVOICE, {
    variables: {organisationId, repeatingInvoiceId},
    flash: 'Repeating invoice created',
    update: (cache, {data: {repeatingInvoice}, errors}) =>
      !errors && clearCache({repeatingInvoices: {accountId: repeatingInvoice.account.id}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_REPEATING_INVOICE, {
    variables: {organisationId, repeatingInvoiceId},
    flash: 'Repeating invoice updated',
    update: (cache, {data: {repeatingInvoice}, errors}) =>
      !errors &&
      clearCache({
        history: {itemType: 'RepeatingInvoice', itemId: repeatingInvoiceId},
        schedule: [{accountId: repeatingInvoice.account.id}]
      })(cache)
  })

  const {destroy, errors: destroyError} = useDestroyable('RepeatingInvoice', repeatingInvoiceId)

  return {
    repeatingInvoice: {
      ...repeatingInvoice,
      lineItems: calculateLineItems(repeatingInvoice.lineItems, repeatingInvoice.taxType)
    },
    errors: createError || updateError || destroyError || {},
    create,
    update,
    destroy
  }
}
